import { FEATURES } from '@constants/Text'
import { registrar } from '@modules/aawz-intelligence-v2/ui-registry'
import aiFrameworkStore from './store/index'
import registryAiFramework from './ia/registry'

/**
 * Ponto de entrada do módulo — chamado por `src/modules/index.js` no boot
 * (`registerModules({ store })`), antes de qualquer rota renderizar.
 *
 * Molde: `src/modules/aawz-intelligence-v2/index.js` (store.registerModule +
 * PERMISSION). Namespace de store literal `aiFramework` — contrato spec-002 §4
 * (ui-components.md).
 *
 * ★ Desde a spec-001 do `plataforma-por-chat` ([T018]), o módulo também liga
 * aqui o seu registry PARCIAL de cartões. O lugar é o mesmo escolhido pelo
 * [T017] no iv2, e pelo mesmo motivo: registrar no IMPORT do `ui-registry`
 * deixaria toda suíte que o importa começando com o agregado cheio, e os casos
 * que montam entradas controladas (`limparRegistry()` + `registrar({...})`)
 * ficariam à mercê da ordem de execução. No boot, o efeito é o que se espera —
 * cada módulo liga o seu parcial ao subir, como já faz com o store.
 */
export function aiFrameworkModule({ store }) {
  store.registerModule('aiFramework', aiFrameworkStore)
  registrar(registryAiFramework)
}

export const PERMISSION = FEATURES.AI_FRAMEWORK
